import { render } from "./AuctionObjectDisplay.vue?vue&type=template&id=d72cc266&scoped=true&ts=true"
import script from "./AuctionObjectDisplay.vue?vue&type=script&lang=ts"
export * from "./AuctionObjectDisplay.vue?vue&type=script&lang=ts"

import "./AuctionObjectDisplay.vue?vue&type=style&index=0&id=d72cc266&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72cc266"]])

export default __exports__